import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ZoomInIcon, XIcon } from 'lucide-react';
import { useBackNavigation } from '../hooks/useBackNavigation';
export function Commission() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const goBack = useBackNavigation('/art');
  const artworks = [{
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-11-18_21-49-20.jpg',
    year: '2025',
    materials: 'Canvas, oil',
    description: 'Bleding ukiyo-e with contemporary art'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-11-18_21-49-26.jpg',
    year: '2025',
    materials: 'Canvas, oil',
    description: 'Mediterranean-inspired portrait'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20241107_202424.jpg',
    year: '2024',
    materials: 'Paper, pencil, marker',
    description: 'Margarita'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/Final%20%E2%9C%A8%EF%B8%8F.png',
    year: '2024',
    materials: 'Paper, pencil, digital art',
    description: 'Rose'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20240902_112216%20(2).jpg',
    year: '2024',
    materials: 'Paper, watercolour',
    description: 'Anita'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/Screenshot_20241018_140701_Instagram%20(1).jpg',
    year: '2023',
    materials: 'Paper, watercolour',
    description: 'Nelly'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-937">
      {/* Image Modal */}
      {selectedImage && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setSelectedImage(null)} data-id="element-938">
          <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white hover:text-cyan-400 transition-colors" data-id="element-939">
            <XIcon className="w-8 h-8" data-id="element-940" />
          </button>
          <motion.img initial={{
        scale: 0.9
      }} animate={{
        scale: 1
      }} src={selectedImage} alt="Enlarged view" className="max-w-full max-h-full object-contain" data-id="element-941" />
        </motion.div>}
      {/* Header */}
      <header className="py-8 px-6 bg-white border-b border-stone-200 sticky top-0 z-40" data-id="element-942">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-943">
          <button onClick={goBack} className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-944">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-945" />
            <span className="font-light" data-id="element-946">Back</span>
          </button>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-947">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-948">
        <div className="max-w-5xl mx-auto" data-id="element-949">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-950">
            <p className="text-emerald-600 font-light tracking-wide uppercase mb-4" data-id="element-951">
              Custom Artwork
            </p>
            <h1 className="text-4xl md:text-6xl font-light text-stone-900 mb-6" data-id="element-952">
              Commission
            </h1>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-953">
              Bespoke pieces created for clients, blending personal vision with
              client requests
            </p>
          </motion.div>
        </div>
      </section>
      {/* Gallery Grid */}
      <section className="py-20 px-6 bg-white" data-id="element-954">
        <div className="max-w-7xl mx-auto" data-id="element-955">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-956">
            {artworks.map((artwork, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group" data-id="element-957">
                <div className="relative overflow-hidden rounded-xl shadow-lg mb-4 aspect-square cursor-pointer" onClick={() => setSelectedImage(artwork.image)} data-id="element-958">
                  <img src={artwork.image} alt={`Artwork ${index + 1}`} className="w-full h-full object-cover" data-id="element-959" />
                  <div className="absolute inset-0 bg-stone-900/0 group-hover:bg-stone-900/10 transition-colors duration-300 flex items-center justify-center" data-id="element-960">
                    <ZoomInIcon className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-961" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-962">
                  <p className="text-sm text-emerald-600 font-light" data-id="element-963">
                    {artwork.year} • {artwork.materials}
                  </p>
                  <p className="text-stone-600 font-light text-sm leading-relaxed" data-id="element-964">
                    {artwork.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}